import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeuix/themes';

export const InciditeThemePreset = definePreset(Aura, {
  //Your customizations, see the following sections for examples
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    colorScheme: {
      dark: {
        primary: {
          color: '#117cfa',
          inverseColor: '#ffffff',
          hoverColor: '#4c9cfb',
          activeColor: '#044ba0',
        },
        surface: {
          0: '#ffffff',
          50: '#f8f9fb',
          100: '#edf0f5',
          200: '#dce1ea',
          300: '#cbd3e0',
          400: '#b9c4d5',
          500: '#97a7c0',
          600: '#748cab',
          700: 'var(--color-surface-3)',
          800: 'var(--color-surface-2)',
          900: 'var(--color-surface-1)',
        },
        highlight: {
          background: '#117cfa',
          focusBackground: '#117cfa',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        formField: {
          background: 'var(--v-input-background)',
          borderRadius: 'var(--v-border-radius)',
          borderColor: '{slate.700}',
          paddingY: '0.25rem',
          paddingX: '0.5rem',
          disabledBackground: '{slate.800}',
        },
        listOption: {
          padding: '0.25rem 0.5rem',
        },
        list: {
          gap: '4px',
        },
      },
    },
  },
  components: {
    chip: {
      root: {
        paddingY: '0.2rem',
        paddingX: '0.5rem',
        background: '{slate.700}',
      },
    },
    paginator: {
      navButton: {
        width: '2rem',
        height: '2rem',
        borderRadius: 'var(--v-border-radius)',
      },
    },
    datatable: {
      row: {
        background: 'var(--color-surface-1)',
      },
    },
    listbox: {
      root: {
        background: 'transparent',
        borderColor: 'transparent',
      },
      list: {
        padding: '0px',
      },
      option: {
        focusBackground: 'transparent',
        selectedBackground: 'transparent',
        selectedFocusBackground: 'transparent',
      },
    },
    dialog: {
      root: {
        borderRadius: 'var(--v-border-radius)',
      },
    },
  },
});
